import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionBarComponent} from './action-bar.component';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';


@NgModule({
  declarations: [ActionBarComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule
  ],
  exports: [ActionBarComponent]
})
export class ActionBarModule {
}
